import React, { useEffect, useState } from 'react';
import { vendor } from '../../model/master';
import { Input, Radio, Select } from 'antd';

interface props {
    vendor: vendor,
    onChange: React.Dispatch<React.SetStateAction<object>>
}

const { Option } = Select;
const { TextArea } = Input;

const VendorDetail: React.FC<props> = (prop) => {

    const [data, setData] = useState<any>({});

    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [taxId, setTaxId] = useState('');
    const [tel, setTel] = useState('');
    const [fax, setFax] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [remark, setRemark] = useState('');


    const init = async () => {
        // setPrivilegeList([
        //     { key: 1, id: 1, name: 'แอดมิน' },
        //     { key: 2, id: 2, name: 'พนักงาน' }
        // ])
    }

    const setInputData = (object: any) => {
        setCode(object.code);
        setName(object.name);
        setTaxId(object.tax_id);
        setTel(object.tel);
        setFax(object.fax);
        setEmail(object.email);
        setAddress(object.address);
        setRemark(object.remark);
    }

    const onDataChange = (e: any) => {
        let key: string = String(e.target.name);
        let value: any = (
            e.target.type === 'checkbox'
                ? (e.target.checked ? 1 : 0)
                : e.target.type === 'radio' ? e.target.value
                : typeof(e.target.value) === 'number' ? Number(e.target.value)
                : String(e.target.value)
        );
        let object: any = data;
        object[key] = value;

        setData(object);
        setInputData(object);
        prop.onChange(object);
    }
    
    useEffect(() => {
        // init();
        setData(prop.vendor);
        setInputData(prop.vendor);
    }, []);


    return (
        <>
            <div className='detailContainer'>
                <div className='detailBox'>
                    <div className='InputBox'>
                        {prop.vendor && prop.vendor.id > 0 && code ? (
                            <div className='formInput'>
                                <label>รหัสผู้ขายส่งสินค้า</label>
                                <div style={{ padding: '6px 0', fontWeight: 700, color: '#475569', fontSize: '15px' }} data-testid="display-vendor-code">
                                    {code}
                                </div>
                            </div>
                        ) : null}
                        <div className='formInput'>
                            <label>ชื่อผู้ขายส่งสินค้า<span> *</span></label>
                            <Input name="name" value={name} placeholder={'กรุณาป้อนชื่อผู้ขายส่งสินค้า'} onChange={onDataChange} />
                        </div>
                        <div className='formInput'>
                            <label>เบอร์โทรศัพท์<span> *</span></label>
                            <Input name="tel" value={tel} placeholder={'กรุณาป้อนเบอร์โทรศัพท์'} onChange={onDataChange} />
                        </div>
                        <div className='formInput'>
                            <label>เลขประจำตัวผู้เสียภาษี</label>
                            <Input name="tax_id" value={taxId} placeholder={'กรุณาป้อนเลขประจำตัวผู้เสียภาษี'} onChange={onDataChange} />
                        </div>
                        <div className='formInput'>
                            <label>เบอร์แฟกซ์</label>
                            <Input name="fax" value={fax} placeholder={'กรุณาป้อนเบอร์แฟกซ์'} onChange={onDataChange} />
                        </div>
                        <div className='formInput'>
                            <label>อีเมล</label>
                            <Input name="email" value={email} placeholder={'กรุณาป้อนอีเมล'} onChange={onDataChange} />
                        </div>
                        <div className='formInput'>
                            <label>ที่อยู่</label>
                            <TextArea
                                name="address"
                                value={address}
                                onChange={onDataChange}
                                placeholder="กรุณาป้อนที่อยู่"
                                autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                        </div>
                        <div className='formInput'>
                            <label>หมายเหตุ</label>
                            <Input name="remark" value={remark} placeholder={'กรุณาป้อนหมายเหตุ'} onChange={onDataChange} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VendorDetail;